<template>
    <form class="tw-flex tw-flex-col tw-w-full tw-h-full"
          v-on:submit.prevent="$emit('submit')">
        <div class="tw-h-16 tw-w-full tw-bg-gradient-to-r tw-from-red-500 tw-to-red-500 tw-via-red-400 tw-flex tw-items-center tw-justify-center tw-px-5 tw-relative">
            <div class="tw-text-xl tw-font-semibold tw-text-white">{{$word.join_matchmarry}}</div>
            <button type="button" v-on:click.prevent="store.closeRequest" class="tw-border-none tw-text-white tw-absolute tw-right-0 tw-top-0 tw-h-full tw-flex tw-items-center tw-justify-center tw-w-12 tw-bg-transparent">
                <i class="bx bx-x tw-text-3xl"></i>
            </button>
        </div>
        <div class="tw-flex-1 tw-overflow-auto tw-flex-shrink">
            <slot></slot>
        </div>
        <div class="tw-flex tw-items-center tw-justify-between tw-p-4">
            <button v-on:click.prevent="store.prev" type="button" class="tw-rounded tw-px-5 tw-py-2 tw-font-semibold tw-border-none tw-text-lg tw-bg-transparent hover:tw-bg-blue-50 tw-text-blue-600 tw-text-center tw-w-40">{{$word.previous}}</button>
            <div>
                <div class="tw-hidden md:tw-flex tw-space-x-2">
                    <div v-for="i in _.range(1,states.steps.length + 1)"
                         class="tw-w-10 tw-h-1"
                         :class="states.current_step === i ? 'tw-bg-red-500' : 'tw-bg-gray-200'"></div>
                </div>
            </div>
            <button v-on:click.prevent="$emit('submit')"  class="tw-rounded tw-h-12 tw-flex tw-items-center tw-justify-center tw-px-5 tw-py-2 tw-bg-red-500 hover:tw-bg-red-600 tw-font-semibold tw-border-none tw-text-lg tw-text-white tw-text-center tw-w-40">
                <i v-if="states.loading" class="bx bx-loader-alt bx-spin tw-text-2xl"></i>
                <span v-else>{{$word.next}}</span>
            </button>
        </div>
    </form>
</template>
<script>
    import store from './register-store'
    export default {
        data : v => ({
            states : store.states
        }),
        created(){
            this.store = store
        }
    }
</script>
